import antd, { notification, Table, message, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import FormControl from '../../../Forms/FormControl';
import { StyleArrivalScheduleForm } from './ArrivalScheduleForm.Style';
import { ArrivalScheduleHandler } from '../ArrivalScheduleHandler';
import { ArrivalScheduleModel } from '../Models/ArrivalScheduleModel';
import ArrivalScheduleDataTable from '../ArrivalScheduleDataTable/ArrivalScheduleDataTable';
import moment from 'moment';
import Utility from 'Core/Utility';
import ConfigUtility from 'Core/ConfigUtility';
import NotificationUtility from 'Core/NotificationUtility';
import { SubmitButton } from 'components/SubmitButton';

const { Form, Icon, Input, Button, DatePicker } = antd;

export interface Props extends FormComponentProps, RouteProps {
  children?: React.ReactNode;
  homeMode?: boolean;
}

export interface State {
  listItems: ArrivalScheduleModel[];
  dateSearched: string;
  shipName: string;
}

class BaseArrivalScheduleForm extends React.Component<Props, State> {
  arrivalScheduleFormHandler: ArrivalScheduleHandler;
  public dataTable: ArrivalScheduleModel = {};
  public dataTableList: ArrivalScheduleModel[] = [{}];

  constructor(props: Props) {
    super(props);
    this.arrivalScheduleFormHandler = new ArrivalScheduleHandler(props);
    this.state = {
      listItems: [],
      dateSearched: '',
      shipName: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getArrivalSchedule = this.getArrivalSchedule.bind(this);
  }

  componentDidMount() {
    const values: ArrivalScheduleModel = { arrivalDateTime: moment().toISOString() }
    this.getArrivalSchedule(values, true);
  }

  // validate confirm either field has a value
  checkBothFields = (rule: any, value: any, callback: any) => {
    const { form } = this.props;
    const expectedArrivalDateTime = form.getFieldValue('arrivalDateTime');
    const shipName = form.getFieldValue('shipName');
    if (!expectedArrivalDateTime && !shipName) {
      callback('Both fields can not be empty!');
    } else {
      callback();
    }
  };

  handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {

      if (!err) {
        this.getArrivalSchedule(values)

      }
    });
  }

  getArrivalSchedule(values: ArrivalScheduleModel, hideError: boolean = false) {
    const vesselScheduleDataList: any = [];

    this.arrivalScheduleFormHandler
      .GetArrivalSchedule(values)
      .then((vesselArrivalSchedule: any) => {
        if (vesselArrivalSchedule.length > 0) {
          vesselArrivalSchedule.forEach((element: any) => {
            element.expectedArrivalDateTime = Utility.ToDateString(moment(element.expectedArrivalDateTime));
            vesselScheduleDataList.push(element);
          });
          this.setState({
            listItems: vesselScheduleDataList,
            dateSearched: !values.arrivalDateTime ? '' : Utility.ToDateString(moment(values.arrivalDateTime)),
            shipName: values.shipName ?? "All Vessels"
          });
        } else {
          this.setState({
            listItems: [],
            dateSearched: !values.arrivalDateTime ? '' : Utility.ToDateString(moment(values.arrivalDateTime)),
            shipName: values.shipName ?? "All Vessels"
          });
          if (!this.props.homeMode && !hideError) {
            NotificationUtility.error('Error', 'No Vessel Reports found', 3, true);
          }
        }
      })
      .catch((error: any) => {
        if (!this.props.homeMode) {
          NotificationUtility.error('Error', 'An error occured trying to retrieve Vessel Schedules', 30, true)
        }
      });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    let state: { from?: any; noPermission?: boolean } = {};

    if (this.props.location) {
      state = this.props.location.state || {};
    }
    const config = ConfigUtility.getSync();
    const dateFormat = config?.Display?.DateFormat;

    return (
      <StyleArrivalScheduleForm onSubmit={this.handleSubmit}>
        {this.props.homeMode === true ? (
          <div> <h3><b>Vessel Schedule</b></h3></div>
        ) : (
          <div>
            <FormControl getFieldDecorator={getFieldDecorator} name="shipName">
              <Input placeholder="Enter Vessel Name" />
            </FormControl>
            <FormControl
              name="arrivalDateTime"
              getFieldDecorator={getFieldDecorator}
              rules={[{ validator: this.checkBothFields }]}>
              <DatePicker
                style={{ width: '100%' }}
                placeholder="Enter Date"
                format={dateFormat}
                {...this.props}
              />
            </FormControl>
            <Form.Item>
              <SubmitButton type="primary" htmlType="submit" style={{ textAlign: "center" }} icon="search">Search</SubmitButton>
              {/* <Button type="primary" htmlType="submit" className="vessel-schedule-form-button">
                  Search
              </Button> */}
            </Form.Item>
          </div>
        )}
        <ArrivalScheduleDataTable
          isHomeMode={this.props.homeMode}
          dateSearched={this.state.dateSearched}
          shipName={this.state.shipName}
          listItems={this.state.listItems}
        />
      </StyleArrivalScheduleForm>
    );
  }
}

const ArrivalScheduleForm = Form.create<Props>({
  name: 'ArrivalSchedule',
})(BaseArrivalScheduleForm);

export default ArrivalScheduleForm;
